module.exports = __webpack_public_path__ + "img/logo.a6391678.png";